import { render, staticRenderFns } from "./CruiseDetailRoute.vue?vue&type=template&id=3a795714&scoped=true"
import script from "./CruiseDetailRoute.vue?vue&type=script&lang=js"
export * from "./CruiseDetailRoute.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailRoute.vue?vue&type=style&index=0&id=3a795714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a795714",
  null
  
)

export default component.exports